import { Box, Chip } from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { TMenuCategory } from "../types";
import appRoutes from "../utils/routes";
import { isDevMode } from "../utils";
import lodash from "lodash";

let skipFirstCategorySelect = true;

const MenuCategoriesPicker: React.FC<{ menuCategories: TMenuCategory[], onCategoryChange: (id: string) => void }> = (props) => {
    const { menuCategories, onCategoryChange } = props;
    const { hash: currentCategoryId } = useLocation();

    useEffect(() => {
        lodash.throttle(() => {
            onCategoryChange(currentCategoryId);
            document.getElementById(currentCategoryId)?.scrollIntoView({ behavior: 'smooth' , block: "nearest", inline: "nearest"})
        }, 100)()
    }, [currentCategoryId])

    useEffect(() => {// mocks first category selection to prevent category scroll
        if (isDevMode()) {
            setTimeout(() => skipFirstCategorySelect = false, 1000) // react dev mode workaround
        } else {
            skipFirstCategorySelect = false
        }
    }, [])

    return <Box
        display={'flex'}
        overflow={'scroll hidden'}
        position={'sticky'}
        top={'32px'}
        sx={{
            zIndex: 2,
            p: '8px 12px',
            background: '#F7F7F7',
            margin: '0 -12px',
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        }}
        onScroll={(event)=>event.preventDefault()}
        >
        {menuCategories.map((category, index) => <HashLink id={'#' + category._id} key={category._id} to={appRoutes.menuCategory(category._id)} smooth>
            <>{(skipFirstCategorySelect && index === 0) || currentCategoryId === '#' + category._id
                ? <Chip label={category.categoryName} variant={'filled'} sx={{ mr: '8px', backgroundColor: '#FFB01D', color: '#FFFFFF' }} />
                : <Chip label={category.categoryName} sx={{ mr: '8px', backgroundColor: '#F7F7F7' }} />
            }</>
        </HashLink>
        )}
    </Box>
}

export default MenuCategoriesPicker;